<div class="column-center complete-registration">
	<h2 class="row-center content-title" i18n="@@registerUser-completeRegistrationTitle">Complete Registration</h2>

	<p class="font-14 content-subtitle center" i18n="@@registerUser-completeRegistrationConfirmRoleCompany">
		You have been added to a {{ assignedRoleName }} role for {{ assignedCompanyName }}
	</p>
	<p class="font-14 content-subtitle center blue" i18n="@@registerUser-completeRegistrationConfirmInfo">
		Please confirm your information below
	</p>

	<div class="column">
		<div class="column">
			<p class="font-14 content-subtitle grey" i18n="@@registerUser-completeRegistrationEmail">Email Address</p>
			<p class="font-14">{{ email }}</p>
		</div>

		<div class="row-space-between">
			<mat-form-field appearance="outline" class="input-200 margin-right-8" subscriptSizing="dynamic">
				<mat-label i18n="@@registerUser-completeRegistrationFirstName">First Name</mat-label>
				<input
					matInput
					[(ngModel)]="firstName"
					(ngModelChange)="disableNextButton()"
					data-automation-id="first-name-input"
				/>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-200 margin-left-8" subscriptSizing="dynamic">
				<mat-label i18n="@@registerUser-completeRegistrationLastName">Last Name</mat-label>
				<input
					matInput
					[(ngModel)]="lastName"
					(ngModelChange)="disableNextButton()"
					data-automation-id="last-name-input"
				/>
			</mat-form-field>
		</div>

		<div>
			<app-contact-phone-type-form
				class="column"
				(userPhoneNumber)="updateUserPhone($event)"
				[existingPhoneNumber]="this.mobilePhoneNumber"
			>
			</app-contact-phone-type-form>
		</div>

		<div class="mobile-font-sm center bottom-padding-8 terms-container">
			<mat-checkbox
				id="accept-terms-checkbox"
				data-automation-id="accept-terms-checkbox"
				[checked]="acceptTerms"
				(change)="acceptTerms = !acceptTerms; disableNextButton()"
			>
				<div class="tos-content">
					<app-tos-and-privacy-policy [showAgreeText]="true"> </app-tos-and-privacy-policy>
				</div>
			</mat-checkbox>
		</div>
	</div>

	<button
		mat-button
		class="primary-button center-unset-width button-width"
		i18n="@@registerUser-completeRegistrationNext"
		[disabled]="this.isNextDisabled"
		(click)="onNextClicked()"
		data-automation-id="complete-registration-next-button"
	>
		Next
	</button>

	<div class="row-center margin-bottom-24">
		<ng-container class="language-dropdown">
			<mat-icon class="language-icon">language</mat-icon>
			<button mat-button [matMenuTriggerFor]="menu" data-automation-id="complete-registration-language-button">
				<span class="language-button">
					<span>{{ siteLanguage }}</span>
					<mat-icon class="language-arrow">arrow_drop_down</mat-icon>
				</span>
			</button>
			<mat-menu #menu="matMenu">
				@for (lang of languageList; track lang) {
					<a
						mat-menu-item
						href="/{{ lang.code }}/register-user?token={{ this.token }}"
						[attr.data-automation-id]="'language-' + lang.label + '-link'"
						>{{ lang.label }}</a
					>
				}
			</mat-menu>
		</ng-container>
	</div>
</div>
